import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { H1 } from '../../app/Pages/League/League.style';

interface PageTitleProps {
  children: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ children }) => (
  <Container className="pt-5">
    <Row className="justify-content-center">
      <Col>
        <H1 className="text-center mb-0">{children}</H1>
      </Col>
    </Row>
  </Container>
);

export default PageTitle;
